module.exports = __webpack_public_path__ + "img/machine.8d6e6c21.svg";